export default __webpack_public_path__ + "static/media/216-england.4d61ac77.svg";